module.exports = __webpack_public_path__ + "img/save-img.c3ba4e06.svg";